import { StrictMode } from "react";
import { ApolloProvider } from "@apollo/client/react";
import { NotificationProvider, ThemeProvider } from "@app/lib/ui-foundation";
import { EventsAdminRbacProvider } from "@app/providers/events-admin-rbac-provider";
import { JwtAuthProvider } from "@app/providers/jwt-auth-provider";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router";
// Framework styles
import "@its-engineering-and-development/ui-foundation/styles/globals.css";
import { App } from "./App";
import { eventsAdminApolloClient } from "./lib/apollo-client";
// App-specific styles
import "./styles/app.css";
import "./styles/detail-sidebar.css";

if (!window.location.hash && window.location.pathname !== "/") {
  const hashPath = `#${window.location.pathname}${window.location.search}`;
  window.history.replaceState(
    null,
    "",
    `${window.location.origin}/${hashPath}`,
  );
}

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApolloProvider client={eventsAdminApolloClient}>
      <HashRouter>
        <ThemeProvider
          defaultColorMode="light"
          storageKey="events-admin-color-mode"
        >
          <NotificationProvider>
            <JwtAuthProvider>
              <EventsAdminRbacProvider>
                <App />
              </EventsAdminRbacProvider>
            </JwtAuthProvider>
          </NotificationProvider>
        </ThemeProvider>
      </HashRouter>
    </ApolloProvider>
  </StrictMode>,
);
